import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=2c3960da&scoped=true"
import script from "./Accordion.vue?vue&type=script&setup=true&lang=ts"
export * from "./Accordion.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./Accordion.vue?vue&type=style&index=0&id=2c3960da&prod&lang=scss&scoped=true"
import style1 from "./Accordion.vue?vue&type=style&index=1&id=2c3960da&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c3960da",
  null
  
)

export default component.exports